import Crud from '../views/Team/Crud'
import Entity from '../views/Team/Add'

let routes = {
    path: '/teams',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/teams/add',
            name: 'NewTeam',
            component: Entity,
            meta: {
                pageTitle: 'team.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'team.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/teams/edit/:id?',
            name: 'EditTeam',
            component: Entity,
            meta: {
                pageTitle: 'team.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'team.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/teams',
            name: 'list-teams',
            component: Crud,
            meta: {
                pageTitle: 'team.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'team.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
